import DiscountBanner from './DiscountBanner'
export default DiscountBanner
